import { AddToCart } from './AddToCart';

export { AddToCart };
export default AddToCart;
